module.exports = {
  HOURLY: 'hourly',
  _24_HOURS: '24-hours',
  ACTUAL: 'actual',
};
